<template>
  <!-- 注册码 -->
  <el-form :model="ruleForm" ref="ruleForm" class="res_code_wrap">
    <div class="title">{{$t('registerEmail_21000').split('|')[0]}} <span>( {{$t('registerEmail_21000').split('|')[1]}} )</span></div>
    <el-form-item class="input" prop="regCode" :rules="[{ required: true, message: $t('registerEmail_21001')}]">
      <el-input :placeholder="$t('registerEmail_21001')" v-model="ruleForm.regCode"></el-input>
    </el-form-item>
    <el-form-item class="input read" prop="check">
      <el-checkbox-group v-model="ruleForm.check">
        <el-checkbox name="check" @click.native="agreementFLAG = true">{{$t("registerEmail_20051")}}</el-checkbox>
      </el-checkbox-group>
      <!-- <a href="./saasAgreement.html" target="_blank" class="agreement">{{$t("registerEmail_20052")}}</a> -->
      <a class="agreement" @click="agreementFLAG = true">{{$t("registerEmail_21007")}}</a><span>{{$t("registerEmail_21009")}}</span><a class="agreement" @click="agreementFLAG = true">{{$t("registerEmail_21008")}}</a>
    </el-form-item>
    <el-form-item>
      <div class="btn">
        <el-button type="primary" @click="registerFirst">{{$t('registerEmail_21003')}}</el-button>
      </div>
    </el-form-item>
    <agreement v-if="agreementFLAG" :visible="agreementFLAG" @cancel="(v) => (agreementFLAG = v)" @handleCheck="getAgreementState"/>
  </el-form>
</template>
<script>
import { requestUrl, ajax, } from "@/assets/utils/network";
import agreement from "@/components/agreement";
export default {
  data() {
    return {
      agreementFLAG: false,
      ruleForm: {
        // 表单内信息
        regCode: "",
        check: false,
      },
    };
  },
  methods: {
    // 注册按钮---下一步
    registerFirst() {
      if (!this.ruleForm.check) {
        this.$message.error(this.$t("registerEmail_21010"));
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          ajax({
            type: "POST",
            url: requestUrl + "/dealerLicenseCode/check",
            data: JSON.stringify({ code: this.ruleForm.regCode }),
            dataType: "json",
            success: (response) => {
              let info = JSON.parse(response);
              if (
                info.error != null &&
                info.error.code == "CODE_NOT_AVAILABLE"
              ) {
                this.$message.error(this.$t("registerEmail_21002"));
                return false;
              }
              this.$emit("next", {
                codeInfo: this.ruleForm,
                stepActive: 1,
                tag: "code",
              });
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取是否同意
    getAgreementState(val) {
      this.ruleForm.check = val === true;
    }
  },
  components: {
    agreement
  }
};
</script>
<style lang="scss" scoped>
.res_code_wrap {
  margin-top: 20%;
  .title {
    color: #464b5c;
    font-size: 14px;
    margin-bottom: 10px;
    span {
      color: #8087a0;
    }
  }
  .read {
    margin-bottom: 40px;
    /deep/.el-form-item__content {
      line-height: 20px;
    }
  }
  /deep/.el-checkbox-group {
    display: inline-block;
  }
  .agreement {
    color: #ff4949;
    cursor: pointer;
  }
  .btn {
    text-align: center;
  }
}
</style>